import React, { useEffect, useState } from "react";
import "./styles/MD_MarketingReport.css";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface Gap {
  heading: string;
  gaps: string;
}

interface ReportData {
  firstName: string;
  lastName: string;
  studyYear: number;
  completedDate: string;
  scores: number[];
  gradeAchieved: number;
  gaps: Gap[];
}

const MarketingReport: React.FC = () => {
  const [data, setData] = useState<ReportData | null>(null);

  useEffect(() => {
    fetchReport();
  }, []);

  const fetchReport = async () => {
    const params = new URLSearchParams({
      SchoolCode: "BRAINBYTES",
      FamilyCode: "annie",
      Login: "Child1",
      ReportNo: "1",
    });

    const res = await fetch(`${API_BASE_URL}api/report/?${params}`);
    const json = await res.json();
    setData(json);
  };

  const handlePrint = () => {
    const params = new URLSearchParams({ ReportNo: "1" });
    window.open(`${API_BASE_URL}api/report/print?${params}`, "_blank");
  };

  if (!data) return <div>Loading...</div>;

  return (
    <div id="page_wrap">
      
      {/* HEADER */}
      <div id="header_bar">
        <div id="top_logo_box_left"></div>
        <div id="top_logo_box"></div>

        <div id="top_text_div">
          <div id="top_name">
            <p>
              <span className="firstname">{data.firstName}</span>{" "}
              <span className="lastname">{data.lastName}</span>
            </p>
          </div>

          <div id="top_title">
            <p>Knowledge of Curriculum Report</p>
          </div>

          <div className="top_details">
            <p>
              School Level: Grade {data.studyYear} / Assessment Completed:{" "}
              {data.completedDate}
            </p>
          </div>

          <div className="top_details2">
            <p>School Level: Grade {data.studyYear}</p>
          </div>

          <div className="top_details2">
            <p>Assessment Completed: {data.completedDate}</p>
          </div>
        </div>
      </div>

      {/* SPEECH */}
      <div className="speech corner">
        <span id="speech_text">Loading...</span>
      </div>

      {/* REPORT */}
      <div id="report_container">
        <div id="tutor_div">
          <div className="play_btn">
            <span className="arrow_right"></span>
          </div>
        </div>

        <hr id="hr_div" />

        {/* WALL */}
        <div id="wall_container">
          <div id="large_gaps_text">
            <p>
              Large knowledge gaps identified for Grade and above
            </p>
          </div>

          {/* GRADES */}
          <div className="grades">
            {data.scores.map((score, i) => (
              <div className="graph_row" key={i}>
                <div className="whiteout_row"></div>

                <div className="grade_box">
                  <p>
                    Grade {i} ({score}%)
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div id="graph"></div>

          {/* PROGRESS BAR */}
          <div className="extras">
            <div className="achieve-container">
              <div className="grade-achieved">
                Grade Levels Achieved
              </div>

              <div className="bar-container">
                <div className="progressbar">
                  <div
                    className="grey-block"
                    id="greymask"
                    style={{
                      width: `${100 - data.gradeAchieved * 10}%`,
                    }}
                  ></div>

                  {[...Array(10)].map((_, i) => (
                    <div className="green-block" key={i}>
                      <div className="top_bar_num">{i}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* GET STARTED */}
            <div id="get_started_div">
              <div id="btnGetStarted">
                <div id="plus"></div>

                <a
                  href="https://www.aplusamerica.com/PURCHASE/EL_InfusionSoftPurchase"
                  className="btnplus_text"
                >
                  GET STARTED
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GAPS */}
      <div id="gaps_container">
        <button
          id="BtnPrintReport"
          className="print_btn"
          onClick={handlePrint}
        >
          Print Report
        </button>

        <p id="gaps_title">
          Maths Doctor® has diagnosed the following gaps in{" "}
          {data.firstName}’s wall of knowledge:
        </p>

        <div id="gaps_box_container">
          {data.gaps.map((gap, i) => (
            <div className="gaps_box" key={i}>
              <div className="gaps_subtitle">
                <span className="gaps_Label">{gap.heading}</span>
              </div>

              <p className="gaps_listing">{gap.gaps}</p>
            </div>
          ))}
        </div>
      </div>

      {/* FOOTER */}
      <div id="footer_div">
        <p>
          <strong>Disclaimer:</strong> Math Doctor® reports are to be used as a guideline only.
        </p>
      </div>
    </div>
  );
};

export default MarketingReport;